import { useState } from 'react';
import { IpermissionGroups, IusersPermissionsData } from '../../../../../types/configuration.types';
import UserPermissionsGroupDropdown from '../UserPermissionsGroupsDropdown/UserPermissionsGroupsDropdown';
import { NudosButton } from '../../../../../components/NudosComponents';
import errorMessage from '../../../../../utils/errorMessage';
import { updatePermissionsGroupByUser } from '../../../../../services/configuration.service';
import alertMessage from '../../../../../utils/alertMessage';
import { isEditingInThisModuleAllowed } from '../../../../LogisticServices/utils/general.utils';
import { getNudosData } from '../../../../../utils/getNudosData';
import './UserPermissionsForm.scss';

const UserPermissionsForm = ({
  userData,
  permissionGroups,
  updateDataCallback
}: {
  userData: IusersPermissionsData;
  permissionGroups?: IpermissionGroups;
  updateDataCallback?: () => void;
}) => {
  const { id, email, userPermissionGroups } = userData;
  const [newPermissionGroups, setNewPermissionGroups] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const userId = getNudosData()?.userData?.id;
  const noGroupIsSelected = !newPermissionGroups.length;

  const handleUpdatePermissionGroups = async () => {
    if (noGroupIsSelected || !userId) return;
    setIsLoading(true);
    try {
      const body = {
        userId: id,
        lastEditUserId: userId,
        newPermissionGroups
      };
      await updatePermissionsGroupByUser(body);
      updateDataCallback && updateDataCallback();
      alertMessage('Se actualizó la información de permisos exitosamente');
    } catch {
      errorMessage();
    } finally {
      setIsLoading(false);
    }
  };

  const isButtonDisabled = isLoading || noGroupIsSelected || !isEditingInThisModuleAllowed();

  return (
    <div className="userPermissionsForm">
      <div className="email">{email}</div>
      <UserPermissionsGroupDropdown
        permissionGroups={permissionGroups || {}}
        currentPermissionGroups={userPermissionGroups}
        updatePermissionGroupsCallback={setNewPermissionGroups}
      />
      <NudosButton
        buttonText="Guardar"
        customWidth="64px"
        customHeight="20px"
        handleClick={handleUpdatePermissionGroups}
        isButtonDisabled={isButtonDisabled}
        isButtonLoading={isLoading}
      />
    </div>
  );
};

export default UserPermissionsForm;
